module.exports = __webpack_public_path__ + "static/media/tj.1d268953.svg";